import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/reveal";

const services = [
  {
    num: "01",
    title: "Permanent Recruitment",
    lead: "For critical, long-term specialist hires.",
    desc: "Supporting companies building strong Cybersecurity, Cloud and Infrastructure teams.",
  },
  {
    num: "02",
    title: "Contract & Interim Talent",
    lead: "Flexible specialist expertise for projects, temporary gaps and changing business needs.",
    desc: "Pre-vetted specialists engaged through a focused, personal search process.",
  },
  {
    num: "03",
    title: "Hiring & Talent Advisory",
    lead: "Support with role definition, recruitment strategy, market insight and specialist hiring challenges.",
    desc: "Clear, honest guidance from a partner who understands technical environments.",
  },
];

const Services = () => (
  <main data-testid="services-page">
    {/* HERO (dark) */}
    <section className="relative bg-[#0B132B] overflow-hidden">
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 orange-glow" />
      <div className="container-nb relative pt-36 pb-20 md:pt-44 md:pb-28">
        <Reveal>
          <p className="eyebrow mb-6">Our Services</p>
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.12] text-[#F8FAFC] max-w-3xl">
            Flexible support for specialist hiring.
          </h1>
        </Reveal>
      </div>
    </section>

    {/* SERVICE BLOCKS (light, editorial) */}
    <section className="bg-[#FAF9F5]">
      <div className="container-nb py-20 md:py-28">
        <div className="max-w-4xl divide-y divide-[#E6E2D8]">
          {services.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.06}>
              <div className="py-10 md:py-14 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10" data-testid={`service-block-${s.num}`}>
                <div className="md:col-span-2">
                  <p className="font-mono-accent text-sm font-semibold text-[#FF5E1A]">{s.num}</p>
                </div>
                <div className="md:col-span-10">
                  <h2 className="font-display text-xl md:text-2xl font-semibold tracking-tight text-[#0F172A] uppercase">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-base md:text-lg text-[#0F172A] leading-relaxed max-w-2xl">{s.lead}</p>
                  <p className="mt-2 text-sm md:text-base text-[#475569] leading-relaxed max-w-2xl">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* CTA (dark + orange gradient) */}
    <section className="relative bg-[#0F172A] overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 55% 65% at 50% 115%, rgba(255,94,26,0.18), transparent 70%)" }} />
      <div className="container-nb relative py-24 md:py-32 text-center">
        <Reveal>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-[#F8FAFC] max-w-2xl mx-auto leading-snug">
            Not sure which service fits?<br />Let's figure it out together.
          </h2>
          <Link to="/contact" data-testid="services-cta-lets-talk" className="btn-primary mt-10 inline-flex">
            Let's Talk About Your Hiring Needs <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
    </section>
  </main>
);

export default Services;
